<template>
  <div class="row description-wrapp">
    <div class="col-lg-12">
      <loader v-if="!isLoaded"></loader>
      <h3 class="page-title">{{'profile.settings_task_type' | trans}}</h3>
      <div class="row">
        <div class="col-md-8 mb-3">
          <div class="box-shadow">
          <div class="row">
            <div class="col-md-12 half_box-container">
              <div v-for="(types, taskTypesIndex) in taskTypes" class="half_box-block mb-4" v-if="types.type.id != 2">

                <h3 class="title-block">{{types.type.title}}</h3>
                <p class="description" v-if="types.type.description">{{types.type.description}}</p>
                <div v-for="(type, index) in types.answers" class="mb-2">
                  <span class="color-block" :style="{background: type.color}">{{type.placeholder | trans}}</span>
                  <mdc-textfield v-model="type.title"
                                 :name="'title_'+index+taskTypesIndex"
                                 maxlength="2"
                                 type="text"
                                 v-validate="'required|max:2'"
                                 data-vv-validate-on="none"
                                 :class="{'is-invalid': errors.has('title_'+index+taskTypesIndex)}"
                                 :data-vv-as="type.placeholder | trans"/>
                  <span :class="{'is-invalid': errors.has('title_'+index+taskTypesIndex)}">{{type.descriptionPlaceholder | trans}}</span>
                  <span class="invalid-feedback" v-if="errors.has('title_'+index+taskTypesIndex)">
                      <strong>{{ errors.first('title_'+index+taskTypesIndex) }}</strong>
                  </span>
                </div>

              </div>
            </div>
            </div>
          </div>

        </div>
        <div class="col-md-4" v-if="hintListRotation">
          <h3 class="title-block">{{hintListRotation.type.title}}</h3>
          <p class="description" v-if="hintListRotation.type.description">{{hintListRotation.type.description}}</p>
            <div v-for="(hint, index) in hintListRotation.prompts" class="mb-2" :class="{'pl-4' : (index === 2 || index === 3 || index === 4 || index === 5)}">
              <span class="color-block" :style="{background: hint.color}">{{hint.placeholder | trans}}</span>
              <mdc-textfield v-model="hint.title"
                             maxlength="3"
                             :name="'hint_title_'+index"
                             type="text"
                             v-validate="'required|max:3'"
                             data-vv-validate-on="none"
                             :class="{'is-invalid': errors.has('hint_title_'+index)}"
                             :data-vv-as="hint.placeholder | trans"/>
              <span :class="{'is-invalid': errors.has('hint_title_'+index)}">{{hint.descriptionPlaceholder | trans}}</span>
              <span class="invalid-feedback" v-if="errors.has('hint_title_'+index)">
                  <strong>{{ errors.first('hint_title_'+index) }}</strong>
              </span>
            </div>

          </div>
        </div>
      </div>

        <div class="col-md-12 mt-3 text-right">
          <button type="submit" class="btn btn-primary col-md-2"
                  @click.prevent="setTaskTypesInfo()">
            {{'behavior.buttons.apply' | trans }}
          </button>
        </div>

    </div>

</template>

<script>

  import Manager from '../api/Manager';
  import TableView from '../../../common/table/components/TableView';
  import Loader from '../../loader/components/Loader';
  import lang from '../../../lang/translator';
  import cloneDeep from 'lodash/cloneDeep';

  export default {
    name: 'TaskTypes',
    props: {

    },
    data() {
      return {
        isLoaded: true,
        taskTypes: null,
        hintListRotation: null
      };
    },

    created() {
      this.getTaskTypesInfo();
    },
    components: {
      TableView, Loader
    },
    methods: {

      async getTaskTypesInfo() {
        let response = await Manager.getTaskTypes();
        this.taskTypes = response.data.data.taskAnswers;
        this.hintListRotation = response.data.data.taskPrompts;
      },

      async setTaskTypesInfo() {
        try {
          this.isLoaded = false;

          let result = await this.$validator.validateAll();
          if (!result) {
            this.isLoaded = true;
            return;
          }

          let response = await Manager.setTaskTypes({
            "items": {
              "taskAnswers": this.taskTypes,
              "taskPrompts": {
                "prompts": this.hintListRotation.prompts,
              }
            },
          });

        } catch (e) {
          console.error('Unknown API error occurred.');
        } finally {
          this.isLoaded = true;
        }
      },

    },

  };
</script>



// WEBPACK FOOTER //
// src/modules/profile/components/TaskTypes.vue